export default "__VITE_ASSET__Bb_93Umq__"